import React, { useEffect, useState } from "react";
import { URL } from "../../../Services/Constant";
import { get, post } from "../../../Services/ApiHandler";
import AlertTypesAndCamera from "../../KnfSuperAdmin/Alert/AlertTypesAndCamera";
import SiteAlertEscalation from "../../SiteAdmin/SiteAlertTypes copy/SiteAlertEscolation";
import SelectBox from "../../../components/SelectBox";
import AlertCompanyIndTypes from "../../KnfSuperAdmin/Alert/AlertCompanyIndTypes";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";

const AlertMainCompany = ({ siteId }) => {
  const givenpermissions = JSON.parse(
    localStorage.getItem("user_permission") ?? "[]",
  );
  const location = useLocation();
  const tab = location?.state?.tab;
  console.log("location prob tab", tab);
  const [site, setSite] = useState([]);
  const [siteList, setSiteList] = useState([]);
  const [alertData, setAlertData] = useState([]);
  const [alertDatas, setAlertDatas] = useState([]);
  const [siteData, setSiteData] = useState([]);
  const [selectedOption, setSelectedOption] = useState(siteId);
  const [activeTab, setActiveTab] = useState(
    tab
      ? tab
      : givenpermissions?.includes("CAN-List-KNF_COMPANY_ALERT_TYPE")
        ? "types"
        : givenpermissions?.includes("CAN-List-KNF_COMPANY_CAMERA")
          ? "camera"
          : "escalation",
  );

  const [newAlertData, setNewAlertData] = useState([]);

  // Add missing state variables
  const [selected, setSelected] = useState([]);
  const [initialSelected, setInitialSelected] = useState([]); // Add this to track initial selections
  const [btn, setBtn] = useState(false);

  // useEffect(() => {
  //   if (tab) return;

  //   const stored = localStorage.getItem("types");
  //   if (stored) {
  //     setActiveTab(JSON.parse(stored));
  //   } else {
  //     setActiveTab("types");
  //     localStorage.setItem("types", JSON.stringify("types"));
  //   }
  // }, []);

  // const getSiteList = () => {
  //   get(URL.ACTIVE_SITE + "?knf_type=1")
  //     .then((res) => {
  //       setSelectedOption([]);
  //       if (res?.sites?.length > 0) {
  //         setSiteList(res?.sites);
  //       } else {
  //         setSiteList([]);
  //         resetAlertStates();
  //         setSelectedOption(null);
  //       }
  //     })
  //     .catch((err) => {
  //       console.log("err", err);
  //     });
  // };

  const handleTab = (type) => {
    setActiveTab(type);
    // localStorage.setItem("types", JSON.stringify(type));
    setSite([]);
  };

  // Modified getAlert to also get selected alert type IDs
  const getAlert = (site_id) => {
    if (!site_id) {
      resetAlertStates();
      return;
    }

    let formdata = new FormData();
    formdata.append("site_id", site_id);
    post(URL.COMPANY_ALERT_TYPES, formdata)
      .then((res) => {
        if (res?.alert_type?.length > 0) {
          let newArr = res?.selected_alert_type?.map((i) => ({
            id: i.alert_type_id,
            severity: i.severity,
          }));

          // console.log("newArr", newArr);

          let newData = res?.alert_type?.map((i) => ({
            ...i,
            severity:
              newArr.find((it) => it.id == i.id)?.severity ?? i.severity,
          }));
          // console.log("newData", newData);

          setAlertData(newData);

          // Check if the response includes selected_alert_type_ids
          if (res?.selected_alert_type_ids?.length > 0) {
            setSelected(res?.selected_alert_type_ids);
            setInitialSelected(res?.selected_alert_type_ids);

            let selectedAlerts = res?.alert_type?.filter((i) =>
              res?.selected_alert_type_ids?.includes(i.id),
            );
            console.log("selectedAlerts", selectedAlerts);
            setNewAlertData(selectedAlerts);
          } else {
            // If no selected IDs in response, you might need to extract from the data
            // This assumes alerts with status or some flag indicating they're selected
            const selectedIds = res?.lists
              .filter((item) => item?.is_selected === 1 || item?.status === 1)
              .map((item) => item?.id);
            setSelected(selectedIds);
            setInitialSelected(selectedIds);
          }
        } else {
          setAlertData([]);
          setSelected([]);
          setInitialSelected([]);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getAlert(siteId);
    getAlertEsculation(siteId);
  }, []);

  const getAlertEsculation = (site_id) => {
    if (!site_id) return;

    let formdata = new FormData();
    formdata.append("site_id", site_id);
    post(URL.SITE_ALERT_ESCULATION_LIST, formdata)
      .then((res) => {
        if (res?.lists?.length > 0) {
          setAlertDatas(res?.lists);
        } else {
          setAlertDatas([]);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const selectAlertTypes = async () => {
    // if (!selectedOption?.value || !siteId) {
    //   toast.error("Please select a site first");
    //   return false;
    // }

    let formdata = new FormData();

    formdata.append("site_id", selectedOption?.value ?? siteId);

    // IMPORTANT FIX FOR UNSELECT ALL
    if (selected?.length > 0) {
      selected.forEach((item, ind) => {
        formdata.append(`alert_type_id[${ind}]`, item);
      });
    } else {
      formdata.append("alert_type_id", "");
    }

    setBtn(true);

    try {
      const res = await post(URL.UPDATE_ALERT_TYPES, formdata);

      if (res?.status === "success") {
        toast.success(res?.message);

        // update initial selection
        setInitialSelected(selected);

        // clear severity locally if all unchecked
        if (selected.length === 0) {
          setAlertData((prev) =>
            prev.map((item) => ({
              ...item,
              severity: "",
            })),
          );

          setNewAlertData([]);
        }

        // refresh latest data
        await getAlert(selectedOption?.value ?? siteId);

        setBtn(false);

        return true;
      } else {
        setSelected(initialSelected);

        setBtn(false);

        return false;
      }
    } catch (err) {
      console.log("errResponse", err);

      setSelected(initialSelected);

      setBtn(false);

      return false;
    }
  };

  // useEffect(() => {
  //   getSiteList();
  // }, []);

  const resetAlertStates = () => {
    setAlertData([]);
    setAlertDatas([]);
    setSelected([]);
    setInitialSelected([]);
    setBtn(false);
    setSite([]);
  };

  return (
    <div className="dashRightView">
      {/* {givenpermissions?.includes("CAN-View-KNF_COMPANY_ALERT_TYPE") && (
        <div className="col-md-3 mb-3">
          <label className="form-label">Select Site</label>
          <SelectBox
            arrayData={siteList}
            data={siteData}
            setData={setSiteData}
            selectedOption={selectedOption}
            setSelectedOption={(val) => {
              resetAlertStates();
              setSelectedOption(val);
              getAlertEsculation(val?.value);
              getAlert(val?.value);
              // Reset selected when site changes (will be set by getAlert)
            }}
            style={true}
            isClearable={false}
          />
        </div>
      )} */}
      <div className="tab-header d-flex gap-3 mb-3">
        {givenpermissions?.includes("CAN-List-KNF_COMPANY_ALERT_TYPE") && (
          <button
            className={`tab-btn ${activeTab === "types" ? "active" : ""}`}
            onClick={() => handleTab("types")}
          >
            Alert Types
          </button>
        )}
        <button
          className={`tab-btn ${activeTab === "escalation" ? "active" : ""}`}
          onClick={() => handleTab("escalation")}
        >
          Alert Escalation Time
        </button>

        {givenpermissions?.includes("CAN-List-KNF_COMPANY_CAMERA") && (
          <button
            className={`tab-btn ${activeTab === "camera" ? "active" : ""}`}
            onClick={() => handleTab("camera")}
          >
            Camera
          </button>
        )}
      </div>

      <div>
        {activeTab === "types" && (
          <AlertCompanyIndTypes
            editable={false}
            alertData={alertData}
            setAlertData={setAlertData}
            selected={selected}
            setSelected={setSelected}
            selectAlertTypes={selectAlertTypes}
            btn={btn}
            site_id={siteId ?? selectedOption?.value}
          />
        )}
        {activeTab === "escalation" && (
          <SiteAlertEscalation
            alertDatas={alertDatas}
            setAlertDatas={setAlertDatas}
            getAlertEsculation={getAlertEsculation}
          />
        )}

        {activeTab === "camera" && (
          <AlertTypesAndCamera
            editable={false}
            alertData={newAlertData}
            data={{
              id: selectedOption?.value ?? siteId,
            }}
          />
        )}
      </div>
    </div>
  );
};

export default AlertMainCompany;
